var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcAssignmentOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-assignment-on_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#458C94",
  d: "m18.744 22.542 1.942 1.942H9.914A2.91 2.91 0 0 1 7 21.57V10.886c0-1.079.864-1.943 1.943-1.943V21.57c0 .535.437.972.971.972zM26.427 10.886v9.83l-1.943-1.933v-9.84c1.069 0 1.943.864 1.943 1.943"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4DCE0",
  d: "M19.482 7a2.89 2.89 0 0 0-2.603 1.612l-.165.33-.165-.33A2.91 2.91 0 0 0 13.945 7h-3.06a1.936 1.936 0 0 0-1.942 1.943V21.57c0 .535.437.972.971.972h6.8v1.942h6.8a2.91 2.91 0 0 0 2.913-2.914v-5.828h-1.942v-6.8A1.94 1.94 0 0 0 22.542 7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M26.563 26.077c-.806.573-1.933.408-2.632-.291l-5.663-5.663a2 2 0 0 1-.583-1.409v-1.223c0-.418.34-.768.767-.768h1.224c.525 0 1.03.214 1.409.583l5.74 5.74a1.994 1.994 0 0 1-.252 3.031z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#458C94",
  d: "M26.563 26.077c-.806.573-1.933.408-2.632-.291l-5.663-5.663a2 2 0 0 1-.583-1.409v-1.223c0-.418.34-.768.767-.768h1.224c.525 0 1.03.214 1.409.583l5.74 5.74a1.994 1.994 0 0 1-.252 3.031z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4AC1CF",
  d: "M16.714 25.455a1.95 1.95 0 0 0 1.942-1.942h-3.885c0 1.068.874 1.942 1.943 1.942"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.003 13.654h9.713a.974.974 0 0 0 .971-.972.974.974 0 0 0-.97-.971h-9.714a.974.974 0 0 0-.972.971c0 .534.437.972.972.972M12.003 17.121h3.885a.974.974 0 0 0 .971-.97.974.974 0 0 0-.971-.972h-3.885a.974.974 0 0 0-.972.971c0 .534.437.971.972.971"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-assignment-on_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h34v34H0z"
})))));
export default SvgIcAssignmentOn;